import { Link } from "react-router-dom";
import { Globe, Facebook, Instagram, Mail } from "lucide-react";
import { LigeriaWordmark } from "@/components/Logo";
import { PANTHER_LINKS, OWNER_EMAIL } from "@/lib/api";

export const Footer = () => (
  <footer className="bg-black border-t border-white/10" data-testid="footer">
    <div className="mx-auto max-w-7xl px-5 md:px-10 py-16 grid gap-12 md:grid-cols-3">
      <div>
        <LigeriaWordmark compact />
        <p className="mt-6 text-sm text-white/50 leading-relaxed max-w-xs">
          Distributeur d'équipements sportifs pour les clubs et les collectivités.
          Catalogue Tremblay 2026 et marque PANTHER.
        </p>
      </div>

      <div>
        <p className="font-accent uppercase tracking-[0.3em] text-sm text-white/40 mb-5">Navigation</p>
        <div className="flex flex-col gap-3 text-sm text-white/70">
          <Link to="/" className="hover:text-blaze transition-colors" data-testid="footer-link-home">Accueil</Link>
          <Link to="/catalogue" className="hover:text-blaze transition-colors" data-testid="footer-link-catalogue">Catalogue Tremblay</Link>
          <Link to="/catalogue#demande" className="hover:text-blaze transition-colors" data-testid="footer-link-quote">Demander un devis</Link>
        </div>
      </div>

      <div>
        <p className="font-accent uppercase tracking-[0.3em] text-sm text-white/40 mb-5">PANTHER</p>
        <div className="flex flex-col gap-3 text-sm text-white/70">
          <a href={PANTHER_LINKS.website} target="_blank" rel="noopener noreferrer" data-testid="footer-panther-website" className="flex items-center gap-3 hover:text-blaze transition-colors">
            <Globe className="h-4 w-4" /> Site web
          </a>
          <a href={PANTHER_LINKS.facebook} target="_blank" rel="noopener noreferrer" data-testid="footer-panther-facebook" className="flex items-center gap-3 hover:text-blaze transition-colors">
            <Facebook className="h-4 w-4" /> Facebook
          </a>
          <a href={PANTHER_LINKS.instagram} target="_blank" rel="noopener noreferrer" data-testid="footer-panther-instagram" className="flex items-center gap-3 hover:text-blaze transition-colors">
            <Instagram className="h-4 w-4" /> Instagram
          </a>
          <Link to="/#demande-panther" data-testid="footer-panther-quote" className="flex items-center gap-3 hover:text-blaze transition-colors">
            <Mail className="h-4 w-4" /> Demander un produit PANTHER
          </Link>
          <a href={`mailto:${OWNER_EMAIL}`} data-testid="footer-contact-email" className="flex items-center gap-3 hover:text-blaze transition-colors">
            <Mail className="h-4 w-4" /> {OWNER_EMAIL}
          </a>
        </div>
      </div>
    </div>
    <div className="border-t border-white/10 py-6 text-center text-xs text-white/35 tracking-widest">
      © 2026 LIGÉRIA SPORT CONCEPT — CATALOGUE TREMBLAY 2026
    </div>
  </footer>
);
